import FastTrack from './FastTrack';

export default FastTrack;
